// @ts-nocheck
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import {
  breakpointsMap,
  SYS_BORDER_RADIUS_MD,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  ThemeProvider,
} from '@oneaudi/unified-web-common';
import { Divider, TextButton, IconButton } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import mapContext from '../../../contexts/map-context';
import { messages } from '../../../i18n/messages';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import Filters from '../Filters/Filters';
import trackingContext from '../../../contexts/tracking-context';
import { trackFilterCancelAction } from '../../../utils/trackingUtils';
import type { UnifiedTheme } from '../../../FeatureApp';

const isLegacy = process.env.IS_LEGACY;

export default function FiltersOverlay() {
  const { results, userSelectedFilters, oneHeader } = mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();
  const initialSelectedFilters = React.useRef([...userSelectedFilters]);
  const { trackingService: tService } = trackingContext.useTrackingState();
  const btnLabel = getButtonLabel(results ? results.length : undefined);

  function getButtonLabel(resultCount: number | undefined) {
    let label = messages.filter_show_no_result;
    if (resultCount) {
      if (resultCount === 1) {
        label = messages.filter_show_one_result;
      }
      if (resultCount > 1) {
        label = messages.filter_show_big_results;
      }
    }
    return useI18n(label, { resultCount: resultCount || '' });
  }

  function applyFilters() {
    dispatch({ type: ActionTypes.setIsFiltersOverlayOpen, payload: false });
  }

  function handleOverlayClose() {
    if (JSON.stringify(initialSelectedFilters.current) !== JSON.stringify(userSelectedFilters)) {
      trackFilterCancelAction(tService, 'FiltersOverlay', window.location.href);
    }
    dispatch({ type: ActionTypes.setFilters, payload: initialSelectedFilters.current });
    dispatch({ type: ActionTypes.setIsFiltersOverlayOpen, payload: false });
  }

  return (
    <ThemeProvider theme={{ name: 'dark' }}>
      <OverlayContainer data-test-id="filters-overlay-component" oneHeader={oneHeader}>
        <CloseButton
          onClick={handleOverlayClose}
          data-test-id="close-button"
          aria-label="close filters"
          className="overlay-close"
          icon="cancel"
          size="md"
          variant="tertiary"
        />
        {isLegacy && <StyledDivider />}
        <Filters />
        <ButtonContainer>
          {isLegacy && <StyledDivider />}
          <TextButton
            variant="primary"
            onClick={applyFilters}
            data-test-id="submit-button"
            disabled={!results || results.length < 1}
            size={isLegacy ? 'md' : 'xs'}
          >
            {btnLabel}
          </TextButton>
        </ButtonContainer>
      </OverlayContainer>
    </ThemeProvider>
  );
}

const OverlayContainer = styled.div<{ oneHeader: boolean }>`
  width: 100%;
  height: 100%;
  padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_350};
  position: relative;
  background: ${(props: UnifiedTheme) =>
    isLegacy
      ? props.theme.sys.color.canvas.default
      : 'linear-gradient(134deg, rgb(44, 52, 63) 0%, rgb(35, 42, 52) 100%)'};
  ${({ oneHeader }) =>
    oneHeader &&
    `position: absolute;
    top:${SYS_SPACE_FIXED_150};
    border-radius: ${SYS_BORDER_RADIUS_MD};
    max-height: 966px;
    box-sizing: border-box;
    `};

  @media (max-width: ${breakpointsMap.md}) {
    position: fixed;
    z-index: 10000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
  }
`;

const CloseButton = styled(IconButton)`
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  line-height: 0;
  position: absolute;
  top: 0;
  right: 0;
`;

const StyledDivider = styled(Divider)`
  border-color: #fff;
`;

const ButtonContainer = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
`;
